<template>
  <div class="row">
    <div class="col col-xxl-7">
      <b-card no-body class="shadow border overflow-hidden">
        <b-card-header :header-class="'text-center text-md-left'">
          {{ $t('Title & Description') }}
        </b-card-header>
        <b-card-body class="p-3 rounded-bottom">
          <validation-observer ref="observer">
            <b-form v-if="!busy" :class="'p-2'" @submit.prevent="save">
              <validation-provider v-slot="{validated, errors, dirty, valid, invalid}" rules="required">
                <b-form-group
                  :label-class="'font-weight-bold'"
                  :label="$t('Trading Name')"
                >
                  <b-form-input
                    v-model.trim="tradingName"
                    v-b-tooltip.focus="nameTooltip"
                    type="text"
                    :placeholder="$t('Company Name Limited')"
                    :state="(dirty || validated) ? (!!valid) : null"
                  />
                  <b-form-invalid-feedback :state="invalid">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{validated, errors, dirty, valid, invalid}" rules="required|wordCount:350">
                <b-form-group
                  :label-class="'font-weight-bold'"
                  :label="$tc('Add description', (350 - parseInt(wordCount(description))))"
                >
                  <b-form-textarea
                    v-model.trim="description"
                    v-b-tooltip.focus.top="descriptionTooltip"
                    :placeholder="$t('Enter description of your company and work (max 350 words)')"
                    rows="6"
                    :state="(dirty || validated) ? (!!valid) : null"
                  />
                  <b-form-invalid-feedback :state="invalid">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider v-slot="{validated, errors, dirty, valid, invalid}" rules="wordCount:50">
                <b-form-group
                  :label-class="'font-weight-bold'"
                  :label="$tc('Directory description', (50 - parseInt(wordCount(shortDescription))))"
                >
                  <b-form-textarea
                    v-model.trim="shortDescription"
                    v-b-tooltip.focus.top="shortDescriptionTooltip"
                    :placeholder="$t('Enter short version of your company\'s description (max 50 words)')"
                    :state="(dirty || validated) ? (!!valid) : null"
                  />
                  <b-form-invalid-feedback :state="invalid">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-form>
            <spinner v-else />
          </validation-observer>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import userDevice from "@/imports/mixins/userDevice";

export default {
  name: "ListingDetails",
  components: {Spinner, ValidationProvider, ValidationObserver},
  mixins: [userDevice],
  props: ['value'],
  data: function () {
    return {
      busy: false,
      listing: this.value,
      focused: {},
    }
  },
  computed: {
    disableSave: function () {
      return this.busy
        || !this.listing
        || this.description === ''
        || this.tradingName === ''
    },
    tradingName: {
      get: function () {
        return this.listing.name ?? '';
      },
      set: function (value) {
        this.listing.name = value;
      }
    },
    description: {
      get: function () {
        return this.listing.description ?? '';
      },
      set: function (value) {
        this.listing.description = value;
      }
    },
    company: function() {
      return this.$store.state.company.COMPANY;
    },
    companyName: function() {
      const {internal_name} = this.company;
      return internal_name;
    },
    shortDescription: {
      get: function () {
        return this.listing.short_description ?? ''
      },
      set: function (value) {
        this.listing.short_description = value;
      }
    },
    nameTooltip: function () {
      return {
        title: this.$t('nameTooltipText') + `<a class="text-link text-link-reset" href="/account/company">` + this.$t('here')+ `</a>`,
        html: true,
        placement: 'top',
      }

    },
    descriptionTooltip: function () {
      return {
        title: this.$t('This is your opportunity to really sell your company'),
        html: true,
        placement: 'top',
      }
    },
    shortDescriptionTooltip: function() {
      return {
        title: this.$t('searchResultsPages'),
        html: true,
        placement: 'top',
      }
    }
  },
  methods: {
    save: function () {
      this.$refs.observer.validate().then(success => {
        if (!success) {
          return;
        }
        if (this.listing.name === null) {
          this.listing.name = this.companyName;
        }
        this.busy = true;
        this.$store.dispatch('saveListing', this.listing).then(() => {
          this.$emit('state', true);
          this.$emit('isSaving', true);
        }).finally(() => {
          this.busy = false;
        })
      });
    },
    focus: function (key, value) {
      this.focused[key] = value;
      this.$emit('focus', this.focused);
    },
    wordCount: function(value) {
      return value.trim().split(" ").length;
    },
  },
  watch: {
    listing: {
      handler: function (value) {
        this.$emit('input', value);
        this.$emit('state', false);
      },
      deep: true
    },
    value: function (value) {
      this.listing = value;
    },
    disableSave: function(value) {
      this.$emit('canSave', !value);
    }
  },
}
</script>

<style scoped>

</style>
